import React, { useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { useGetSiteQuery, useGetWalletThemeQuery } from "features/site/siteApi";
import { useAccountQuery } from "features/auth/authApi";
import { DEFAULT_WALLET_THEME } from "theme/defaultWalletTheme";
import { normalizeWalletTheme } from "theme/normalizeWalletTheme";
import { createAppTheme } from "theme/createAppTheme";

type AppThemeProviderProps = {
  children: React.ReactNode;
  previewKycProgramId?: number | null;
};

const AppThemeProvider = ({
  children,
  previewKycProgramId = null,
}: AppThemeProviderProps) => {
  const { data: siteData } = useGetSiteQuery();
  const { data: account } = useAccountQuery();

  const kycProgramId =
    previewKycProgramId ?? account?.user?.wallet?.kyc_program_id ?? undefined;

  const { data: programTheme } = useGetWalletThemeQuery(kycProgramId, {
    skip: !kycProgramId,
  });

  const resolvedWalletTheme = useMemo(
    () =>
      normalizeWalletTheme(
        programTheme ?? siteData?.walletTheme ?? DEFAULT_WALLET_THEME
      ),
    [programTheme, siteData?.walletTheme]
  );

  const theme = useMemo(
    () => createAppTheme(resolvedWalletTheme),
    [resolvedWalletTheme]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AppThemeProvider;
